import * as React from "react";

function JobRequets({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 23" fill="none" {...props}>
      <path
        d="M12.666 21.923h-11c-.333 0-.666-.35-.666-.698V5.533c0-.348.333-.697.667-.697h11c.333 0 .666.349.666.697v15.692c0 .349-.333.698-.667.698z"
        stroke={color}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.667 4.836V1.785c0-.436.333-.785.75-.785H16.25c.417 0 .75.349.75.785v15.517c0 .436-.333.785-.75.785h-3"
        stroke={color}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default JobRequets;
